const LEGACY_ASSET_ORIGIN = 'https://edudata.computingis.fun'
const CURRENT_ASSET_ORIGIN = 'https://qn-edudata.oss-cn-beijing.aliyuncs.com'

const RESOURCE_ATTRIBUTES = ['src', 'href', 'poster', 'data', 'srcset', 'style']

export function replaceLegacyAssetUrl(value) {
  if (typeof value !== 'string' || !value.includes(LEGACY_ASSET_ORIGIN)) {
    return value
  }
  return value.split(LEGACY_ASSET_ORIGIN).join(CURRENT_ASSET_ORIGIN)
}

export function replaceLegacyAssetUrlsDeep(value, visited = new WeakSet()) {
  if (typeof value === 'string') {
    return replaceLegacyAssetUrl(value)
  }
  if (!value || typeof value !== 'object' || visited.has(value)) {
    return value
  }

  visited.add(value)
  Object.keys(value).forEach(key => {
    value[key] = replaceLegacyAssetUrlsDeep(value[key], visited)
  })
  return value
}

function replaceElementResourceAttributes(element) {
  if (!(element instanceof Element)) {
    return
  }

  RESOURCE_ATTRIBUTES.forEach(attribute => {
    const value = element.getAttribute(attribute)
    const replacedValue = replaceLegacyAssetUrl(value)
    if (replacedValue !== value) {
      element.setAttribute(attribute, replacedValue)
    }
  })
}

function replaceResourcesInTree(root) {
  replaceElementResourceAttributes(root)
  root.querySelectorAll?.('*').forEach(replaceElementResourceAttributes)
}

export function installLegacyAssetCompatibility(root = document.documentElement) {
  replaceResourcesInTree(root)

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes') {
        replaceElementResourceAttributes(mutation.target)
        return
      }
      mutation.addedNodes.forEach(replaceResourcesInTree)
    })
  })

  observer.observe(root, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: RESOURCE_ATTRIBUTES,
  })
  return observer
}
